import bus from "@/bus";
import pixelDb from "./pixelDb";
import pxRunner from "./runner";

const pixels = {
  initProvider(key, provider, Vue) {
    pxRunner.enableProvider(provider, () => {
      Vue.$log.info(
        "se habilitó el provider: " +
          key +
          ". Ejecutando la cola de pxs probablemente llamados"
      );

      if (provider.queue && provider.queue.length > 0) {
        for (let q of provider.queue) {
          Vue.$log.info("procesando cola de provider: " + key);
          q();
        }
      }
    });
  },
  install(Vue) {
    for (let key in pixelDb.providers) {
      pixels.initProvider(key, pixelDb.providers[key], Vue);
    }

    bus.$on("mutation", (mutationObj) => {
      let mutation = mutationObj.mutation;
      // Hay un trigger para este tipo de mutation ?
      let trigger = pixelDb.triggers[mutation.type];
      if (trigger) {
        // El trigger 'onRoute' lleva el nombre del route, dentro del payload
        let phases = null;
        if (mutation.type === "onRoute") {
          phases = trigger[mutation.payload.name];
        } else {
          phases = trigger;
        }
        // Si tiene phases avanzo
        if (phases) {
          for (let phase of phases) {
            pxRunner.run(phase, mutationObj);
          }
        }
      }
    });
  },
};

export default pixels;
